function SuccessMessage({ show, children }) {
    if (!show) return null
    return <div className="login-success col-12 mb-1">{children}</div>
}

export default SuccessMessage
